'use client';

import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class AuthErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Check if it's an auth-related error
    if (error.message?.includes('auth') || error.message?.includes('session') || error.message?.includes('fetch')) {
      return { hasError: true, error };
    }
    return { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // Log error but don't crash the app
    console.error('Auth error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Silently handle auth errors - the middleware will redirect to login if needed
      return this.props.children;
    }

    return this.props.children;
  }
}


